module.exports = __webpack_public_path__ + "static/media/ic_link_tiktok.ad48c3fe.svg";